import React from "react";

export default () => {
  return (
    <nav>
      <div className="nav-wrapper">
        <a
          href="/"
          style={{
            fontSize: "1.9rem",
            display: "flex",
            justifyContent: "center"
          }}
        >
          Web App Manifest Generator
        </a>
      </div>
    </nav>
  );
};
